/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Column, Entity } from 'typeorm';
import { DatabaseUserAttribute } from './database-user-attribute.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { DatabaseUserGroup } from './database-user-group.model';

@Entity()
export class DatabaseUser extends SmBaseEntity {
    @Column({default: "", unique: true})
    userName: string = "";

    @Column({default: ""})
    passwordHash: string = "";

    @Column({default: ""})
    firstName: string = "";

    @Column({default: ""})
    lastName: string = "";

    @Column({ default: "", length: 10_000 })
    mail: string = "";

    @Column({default: "", length: 1})
    gender: string = "";

    @Column({default: true})
    active: boolean = true;

    @Column({default: false})
    mustChangePassword: boolean = false;

    @Column({default: ""})
    passwordResetHash: string = "";

    @Column({default: ""})
    phone: string = "";

    @Column({default: false})
    activated: boolean = false;

    @Column({default: "" })
    activationCode: string = "";

    @Column({nullable: true})
    @Type(() => Date)
    activationExpires: Date = null;

    @Column({nullable: false, default: true})
    sendNotificationMails: boolean = true;

    @Column({default: false})
    isAdmin: boolean = false;

    @Column("text", { array: true, nullable: true })
    recoveryQuestions: string[] = [];

    @Column("text", { array: true, nullable: true })
    recoveryAnswers: string[] = [];

    @Column({default: false})
    privacyPolicyAccepted: boolean = false;

    @Column({default: ""})
    source: string = "";

    @Type(() => DatabaseUserAttribute)
    attributes: DatabaseUserAttribute[] = [];

    @Type(() => DatabaseUserGroup)
    groups: DatabaseUserGroup[] = [];

    getStringRepresentation(): string {
        return Utils.stringDef(this.getFullName(), this.userName);
    }

    getFullName(): string {
        return (Utils.stringDef(this.firstName) + " " + Utils.stringDef(this.lastName)).trim();
    }

    resetToInitial(passwordHash: string): void {
        this.passwordHash = passwordHash;
        this.mustChangePassword = true;
        this.recoveryQuestions = [];
        this.recoveryAnswers = [];
    }

    getAttributeValue(name: string): string {
        let attrib = this.attributes.find(a => a.key == name);
        if (attrib == null) {
            throw new Error("Das Benutzer-Attribut '" + name + "' wurde nicht gefunden. Verfügbare Attribute: " + Utils.arrayItemsToString(this.attributes, ", ", a => a.key));
        }
        return attrib.value; 
    }

    getAttributeValueBool(name: string): boolean {
        return Utils.toBool(this.getAttributeValue(name)); 
    }

    getAttributeValueNumber(name: string): number {
        return Utils.toNumber(this.getAttributeValue(name)); 
    }
}
